import React, { useState } from "react";
import T21 from "../components/calculator/T21";
import T180 from "../components/calculator/T180";
import { Box, Tab, Tabs } from "@mui/material";
import useCalculator from "../hooks/useCalculator";
import { isVideov2 } from "../helpers/isVideo";
import { useLocation } from "react-router";
import { Helmet, HelmetProvider } from "react-helmet-async";

const Calculator = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { calculator } = useCalculator(false);
  const [key, setKey] = useState(queryParams.get('t180') ? queryParams.get('t180') : false);

  return (
    <>
    <HelmetProvider>
        <Helmet prioritizeSeoTags>
          <title>Calculadora de losas con Viguetas Tensolite T21 y T180</title>
          <meta name="title" content="Tensolite | Fábrica de Premoldeados y Pretensados de Hormigón" />
          <meta name="description" content="Fábrica de premoldeados y pretensados de hormigón. Vigueta, bloque, adoquín, teja y productos especiales de hormigón. Obras públicas y civiles." />
          <meta itemProp="image" content="https://tensolite.com/images/redes.png" />
          <meta name="author" content="Sitenso"></meta>

          <meta property="og:type" content="website" />
          <meta property="og:url" content={`https://tensolite.com`} />
          <meta property="og:title" content="Tensolite | Fábrica de Premoldeados y Pretensados de Hormigón" />
          <meta property="og:description" content="Fábrica de premoldeados y pretensados de hormigón. Vigueta, bloque, adoquín, teja y productos especiales de hormigón. Obras públicas y civiles." />
          <meta property="og:image" content="https://tensolite.com/images/redes.png" />

          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:url" content={`https://tensolite.com`} />
          <meta property="twitter:title" content="Tensolite | Fábrica de Premoldeados y Pretensados de Hormigón" />
          <meta property="twitter:description" content="Fábrica de premoldeados y pretensados de hormigón. Vigueta, bloque, adoquín, teja y productos especiales de hormigón. Obras públicas y civiles." />
          <meta property="twitter:image" content="https://tensolite.com/images/redes.png" />
        </Helmet>
      </HelmetProvider>
      <div
        id="calculadora"
        aria-labelledby="calculadora-intro"
        className="bg-fullpage"
      >
        {key ? (
          <picture>
            {isVideov2(calculator?.t180?.[0]?.imageCover?.[0]?.url) ? (
              <video
                className="imagen-fondo img-responsive-inter"
                src={calculator?.t180?.[0]?.imageCover?.[0]?.url}
              />
            ) : (
              <>
                <source
                  media="(orientation: portrait) and (max-width: 767px)"
                  srcSet={
                    calculator?.t180?.[0]?.imageCover_mobile
                      ? calculator?.t180?.[0]?.imageCover_mobile?.[0]?.url
                      : ""
                  }
                  alt={
                    calculator?.imageCover_mobile
                      ? calculator?.t180?.[0]?.imageCover_mobile?.[0].alt
                      : ""
                  }
                  className="imagen-fondo img-responsive-inter"
                  title="calculadora"
                />
                <source
                  media="(orientation: landscape) and (max-width: 767px)"
                  srcSet={
                    calculator?.t180?.[0]?.imageCover
                      ? calculator?.t180?.[0]?.imageCover?.[0]?.url
                      : ""
                  }
                  alt={
                    calculator?.imageCover
                      ? calculator?.t180?.[0]?.imageCover?.[0]?.alt
                      : ""
                  }
                  className="imagen-fondo img-responsive-inter"
                  title="calculadora"
                />
                <img
                  className="imagen-fondo img-responsive-inter"
                  src={
                    calculator?.t180?.[0]?.imageCover
                      ? calculator?.t180?.[0]?.imageCover?.[0]?.url
                      : ""
                  }
                  alt={
                    calculator?.imageCover
                      ? calculator?.t180?.[0]?.imageCover?.[0]?.alt
                      : ""
                  }
                  title="calculadora"
                />
              </>
            )}
          </picture>
        ) : (
          <picture>
            {isVideov2(calculator?.t21?.[0]?.imageCover?.[0]?.url) ? (
              <video
                className="imagen-fondo img-responsive-inter"
                src={calculator?.t21?.[0]?.imageCover?.[0]?.url}
                controls
              />
            ) : (
              <>
                <source
                  media="(orientation: portrait) and (max-width: 767px)"
                  srcSet={
                    calculator?.t21?.[0]?.imageCover_mobile
                      ? calculator?.t21?.[0]?.imageCover_mobile?.[0]?.url
                      : ""
                  }
                  alt={
                    calculator?.imageCover_mobile
                      ? calculator?.t21?.[0]?.imageCover_mobile?.[0]?.alt
                      : ""
                  }
                  className="imagen-fondo img-responsive-inter"
                  title="calculadora"
                />
                <source
                  media="(orientation: landscape) and (max-width: 767px)"
                  srcSet={
                    calculator?.t21?.[0]?.imageCover
                      ? calculator?.t21?.[0]?.imageCover?.[0]?.url
                      : ""
                  }
                  alt={
                    calculator?.imageCover
                      ? calculator?.t21?.[0]?.imageCover?.[0]?.alt
                      : ""
                  }
                  className="imagen-fondo img-responsive-inter"
                  title="calculadora"
                />
                <img
                  className="imagen-fondo img-responsive-inter"
                  src={
                    calculator?.t21?.[0]?.imageCover
                      ? calculator?.t21?.[0]?.imageCover?.[0]?.url
                      : ""
                  }
                  alt={
                    calculator?.imageCover
                      ? calculator?.t21?.[0]?.imageCover?.[0]?.alt
                      : ""
                  }
                  title="calculadora"
                />
              </>
            )}
          </picture>
        )}

        <div className="container">
          {key ? (
            <header id="calculadora-intro">
              <h1>{calculator?.t180?.[0]?.title}</h1>
              <p>
                <b>{calculator?.t180?.[0]?.subtitle}</b>
              </p>
              <p>{calculator?.t180?.[0]?.description}</p>
            </header>
          ) : (
            <header id="calculadora-intro">
              <h1>{calculator?.t21?.[0]?.title}</h1>
              <p>
                <b>{calculator?.t21?.[0]?.subtitle}</b>
              </p>
              <p>{calculator?.t21?.[0]?.description}</p>
            </header>
          )}

          <Box className="tabs-contact">
            <Tabs aria-label="icon label tabs example">
              <Tab
                value="T21"
                className={`icon-tab ${!key && "active"}`}
                label="T21"
                aria-labelledby="Calculadora T21"
                aria-label="Calculadora T21"
                onClick={() => setKey(false)}
              />
              <Tab
                value="T180"
                className={`icon-tab ${key && "active"}`}
                label="T180"
                aria-labelledby="Calculadora T180"
                aria-label="Calculadora T180"
                onClick={() => setKey(true)}
              />
            </Tabs>
          </Box>
        </div>
      </div>

      {key ? <T180 /> : <T21 />}
    </>
  );
};

export default Calculator;
